import { KgMobileCall_native } from './lib/mobilecall';
import { UA, nativeCall, $extend } from './lib/util';
import './lib/QQshare';
import wxEnvir from '@kugou/wx-environment';
import wxShareTest from './lib/wxShareTest';
window.KgWebMobileCall = window.KgWebMobileCall || {};
/**
 * ============================================================================
 * 自定义分享数据（默认值）
 * @param {string} [plat] 分享到的平台
 * ============================================================================
 */

var shareData = {
  title: document.title,
  url: location.href,
  content: '',
  img: "",
  projectid: "1018"
};
/**
 * ============================================================================
 * 分享到各平台
 * @param {string} [plat] 分享到的平台
 * ============================================================================
 */

var shareToPlat = function () {
  var option = {
    /*新开窗口宽度*/
    popupWidth: 615,

    /*新开窗口高度*/
    popupHeight: 505,

    /*分享标题*/
    title: '',

    /*分享链接*/
    url: '',

    /*分享内容*/
    content: '',

    /*分享图片地址*/
    img: '',

    /*分享视频swf地址*/
    swf: '',

    /*(腾讯微博,网易微博) 用参数，您的网站地址(可选)*/
    site: '',

    /*(新浪微博,腾讯微博) 用参数，您申请的应用appkey,显示分享来源(可选)*/
    appkey: '',

    /*(139微博，网易微博) 用参数，分享来源*/
    source: '',

    /*(新浪微博) 用参数,关联用户的UID，分享微博会@该用户(可选)*/
    ralateUid: ''
  };
  var winSrc = '';
  var queryStr = '';
  var showPopup = true;

  function sharePlat(plat) {
    var _title = encodeURIComponent(option.title);

    var _url = encodeURIComponent(option.url);

    var _content = encodeURIComponent(option.content);

    var _img = encodeURIComponent(option.img);

    var _hdImg = option.hdImg ? encodeURIComponent(option.hdImg) : '';

    var _swf = encodeURIComponent(option.swf || '');

    switch (plat) {
      case 'qzome':
      case 'qzone':
        winSrc = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey';
        queryStr = ['url=' + _url, 'title=' + _title, 'desc=' + _content, 'pics=' + _img, 'summary=' + _content].join('&');
        break;

      case 'rr':
        option.popupHeight = 560;
        winSrc = 'https://widget.renren.com/dialog/share';
        queryStr = ['link=' + _url, 'title=' + _title, 'image_src=' + _img, 'description=' + _content].join('&');
        break;

      case 'sina':
        option.popupWidth = 615;
        option.popupHeight = 505;
        winSrc = 'https://service.weibo.com/share/share.php';
        queryStr = ['url=' + _url, 'appkey=' + option.appkey, 'title=' + _title, 'pic=' + (_hdImg ? _hdImg : _img), 'ralateUid=' + option.ralateUid].join('&');
        break;

      case 'qq':
        option.popupWidth = 700;
        option.popupHeight = 680;

        var _appkey = encodeURIComponent(option.appkey); //你从腾讯获得的appkey


        var _pic = _img; //（例如：var _pic='图片url1|图片url2|图片url3....）

        winSrc = 'https://v.t.qq.com/share/share.php';
        queryStr = ['title=' + _title, 'url=' + _url, 'appkey=' + _appkey, 'site=' + option.site, 'pic=' + _pic].join('&');
        break;

      case 'qq_client':
        option.popupWidth = 765;
        option.popupHeight = 620;
        winSrc = 'https://connect.qq.com/widget/shareqq/index.html';
        queryStr = ['title=' + _title, 'desc=' + _content, 'url=' + _url, 'site=' + option.site, 'pics=' + _pic, 'flash=' + _swf, 'summary=' + encodeURIComponent('听音乐，找酷狗')].join('&');
        break;

      default:
        return;
    }

    ;
  }

  function showPopupFun() {
    var l = (screen.width - option.popupWidth) / 2;
    var t = (screen.height - option.popupHeight) / 2;
    var resultUrl = winSrc + '?' + queryStr;

    if (showPopup) {
      if (!window.open(resultUrl, '_blank', 'width=' + option.popupWidth + ',height=' + option.popupHeight + ',left=' + l + ',top=' + t)) {
        location.href = resultUrl;
      }

      ;
    }
  }

  function init(plat, opt) {
    option = $extend(option, opt || {});
    sharePlat(plat);
    showPopupFun();
  }

  return {
    init: init
  };
}();
/**
 * ============================================================================
 * QQ分享
 * ============================================================================
 */


var QQShareModule = function () {
  if (UA.isMobileQQ) {
    share(shareData);
  }

  function share(shareData) {
    if (window.setShareInfo) {
      window.setShareInfo({
        title: shareData.title,
        summary: shareData.content,
        pic: shareData.img,
        url: shareData.url
      });
    }
  }

  return {
    share: share
  };
}();
/**
 * ============================================================================
 * 微信分享
 * ============================================================================
 */


var wxShareModule = function () {
  if (/MicroMessenger/i.test(navigator.userAgent)) {
    wxEnvir.init(function () {
      wxShare(shareData);
    });
  }

  function wxShare(shareData) {
    wxEnvir.share(shareData);
  }

  return {
    wxShare: wxShare
  };
}();
/**
 * ============================================================================
 * 分享逻辑
 * ============================================================================
 */


var shareModule = function (KgMobileCall) {
  var timer;
  /**
   * 微信中使用的分享
   * @return {[type]} [description]
   */

  function shareWx() {
    if (document.getElementById("alertWeixin")) {
      document.getElementById("alertWeixin").remove();
    }

    var alertWeixinDom = document.createElement("div");
    alertWeixinDom.style.cssText = "position: fixed;top: 0;left: 0;width: 100%;height: 100%;z-index: 10000;background: rgba(0,0,0,.7);";
    alertWeixinDom.id = "alertWeixin";
    document.body.appendChild(alertWeixinDom);
    alertWeixinDom.innerHTML = ' <img src="https://imgessl.kugou.com/h5_pic/20160526105745452169.png" style="width: 100%;display: block;">';
    clearTimeout(timer);
    alertWeixinDom.addEventListener("click", function () {
      clearTimeout(timer);

      if (document.getElementById("alertWeixin")) {
        document.getElementById("alertWeixin").remove();
      }
    });
    timer = setTimeout(function () {
      if (document.getElementById("alertWeixin")) {
        document.getElementById("alertWeixin").remove();
      }
    }, 3000);
  }
  /*
   *非客户端时使用的分享
   */


  function shareOther() {
    shareToPlat.init('sina', shareData);
  }

  function shareAll() {
    //端内分享上报
    // if (KgMobileCall.isInClient() && shareData.url && shareData.projectid) {
    //     wxShareTest.mobileLog(shareData.url, shareData.projectid, 1);
    // }
    //分享微信小程序
    if (KgMobileCall.isInClient() && shareData.type == 5) {
      KgMobileCall.shareMiniProgram({
        type: shareData.mpType || 1,
        id: shareData.id || '',
        url: shareData.url || location.href,
        path: shareData.path || '',
        ver: shareData.ver || 0,
        title: shareData.title || document.title,
        doc: shareData.content || '',
        pic: shareData.img
      });
      return;
    }

    if (UA.isFanxing) {
      var shareObject = {
        "image": shareData.img,
        "link": shareData.url || location.href,
        "desc": shareData.content,
        "title": shareData.title || document.title
      };
      var json = {
        "shareList": ["onShareWechat", "onShareTimeline", "onShareQQ", "onShareQzone", "onShareSina"],
        "onShareWechat": shareObject,
        "onShareTimeline": shareObject,
        "onShareQQ": shareObject,
        "onShareQzone": shareObject,
        "onShareSina": shareObject
      };
      nativeCall({
        "cmd": "610",
        "jsonStr": json,
        "callbackName": "mobileCall.FxShare"
      });
    } else {
      var shareDataObj;

      if (shareData.type == 4) {
        shareDataObj = {
          'linkUrl': encodeURIComponent(shareData.url || location.href),
          'content': shareData.content,
          'title': shareData.title || document.title,
          'imageData': shareData.img,
          'screenshot': shareData.screenshot || false,
          'copyContent': shareData.copyContent || ""
        };
      } else {
        shareDataObj = {
          'linkUrl': encodeURIComponent(shareData.url || location.href),
          'picUrl': shareData.img,
          'content': shareData.content,
          'title': shareData.title || document.title,
          'copyContent': shareData.copyContent || "",
          'shareChannel': shareData.shareChannel || [1, 2, 3, 4, 5]
        };
      }

      var data = {
        'type': shareData.type || '3',
        'shareName': shareData.shareName || '',
        'hash': shareData.hash || '',
        'listID': shareData.listID || '',
        'suid': shareData.suid || '',
        'slid': shareData.slid || '',
        'imgUrl': shareData.imgUrl || '',
        'filename': shareData.filename || '',
        'duration': shareData.duration || '',
        'topicName': shareData.topicName || '',
        'singerName': shareData.singerName || '',
        'needSkin': shareData.needSkin == 0 ? 0 : 1,
        'shareData': shareDataObj
      };

      if (shareData.platform) {
        data["platform_type"] = shareData.platform;
      }

      if (shareData.multiCB) {
        data.multiCB = shareData.multiCB;
        KgMobileCall.share(data, null, shareWx, shareOther);
      } else {
        if (shareData.hdImg || shareData.wbContent) {
          var wbImg = shareData.hdImg || shareData.img;
          window.getBase64(wbImg, function (hdImg) {
            window.multiCallBack = function () {
              var shareJson = {
                'type': "weibo",
                'linkUrl': shareData.url || location.href,
                'content': shareData.wbContent || shareData.content,
                'title': shareData.title || document.title,
                'list': [hdImg]
              };
              KgMobileCall.multiShare(shareJson);
            };

            data.multiCB = "multiCallBack";
            KgMobileCall.share(data, null, shareWx, shareOther);
          });
        } else {
          KgMobileCall.share(data, null, shareWx, shareOther);
        }
      }
    }
  }

  function setShareData(data) {
    if (data.content && data.content.length > 40) {
      data.content = data.content.substring(0, 40);
    }

    shareData = $extend(shareData, data || {}); //如果页面有注入切换域名
    // if (window._COMMON_CONFIG_ && window._COMMON_CONFIG_.shareDomain) {
    //     shareData.url = shareData.url.replace(/\/\/\S+.kugou.com/g, '//' + window._COMMON_CONFIG_.shareDomain);
    // }
    //微信分享链接校验
    // if (KgMobileCall.isInClient() && shareData.url && shareData.projectid) {
    //     var shareUrl = shareData.url;
    //     wxShareTest.testUrl(shareUrl, shareData.projectid, function (res) {
    //         if (shareUrl == shareData.url) {
    //             shareData.url = res.url;
    //         }
    //     })
    // }
    //微信环境曝光上报
    // if (!KgMobileCall.isInClient() && (/MicroMessenger/i).test(navigator.userAgent) && shareData.url && shareData.projectid) {
    //     wxShareTest.mobileLog(shareData.url, shareData.projectid, 2);
    // }
  }

  function resetShareData(data) {
    setShareData(data);
    QQShareModule.share(shareData);
    wxShareModule.wxShare(shareData); // shareAll();
  }

  function resetShare(data) {
    setShareData(data);
    QQShareModule.share(shareData);
    wxShareModule.wxShare(shareData);
    shareAll();
  }

  return {
    setShareData: setShareData,
    shareAll: shareAll,
    shareWx: shareWx,
    shareOther: shareOther,
    resetShareData: resetShareData,
    resetShare: resetShare
  };
}(KgMobileCall_native);

export default shareModule;